<template>
  <div class="settings-wrapper bg-pattern-gray">
    <div class="w-100 d-flex justify-content-center settings-header">
      <nav class="navbar navbar--horizontal" :class="{ 'limited-company': isLimitedCompany }">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'general' }"
              @click="activeName = 'general'"
              >General</a
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'profile' }"
              @click="activeName = 'profile'"
              >Profile</a
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'control_panel' }"
              @click="activeName = 'control_panel'"
              >Control Panel</a
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'tax_and_registration' }"
              @click="activeName = 'tax_and_registration'"
              >Tax Reg.</a
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'banking_and_paypal' }"
              @click="activeName = 'banking_and_paypal'"
              >Banking</a
            >
          </li>
          <!-- <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'accountant' }"
              @click="activeName = 'accountant'"
              >Accountant</a
            >
          </li> -->
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'subscription' }"
              @click="activeName = 'subscription'"
              >Subscription</a
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'change_password' }"
              @click="activeName = 'change_password'"
              >Change Password</a
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: activeName === 'voucher_referral_and_share' }"
              @click="activeName = 'voucher_referral_and_share'"
              >Voucher</a
            >
          </li>
        </ul>
      </nav>
    </div>

    <div class="tab-content row">
      <div v-if="activeName === 'general'" class="col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 mx-auto">
        <General></General>
      </div>
      <div v-if="activeName === 'profile'" class="col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 mx-auto">
        <template v-if="isSoleTrader">
          <div class="st-heading st-heading--navy">Sole trader</div>
          <div class="st-wizard">
            <div class="st-card">
              <SoleTraderForm></SoleTraderForm>
            </div>
          </div>
        </template>
        <template v-else-if="isLimitedCompany">
          <div class="st-heading st-heading--teal">Limited company</div>
          <div class="st-wizard">
            <div class="st-card">
              <LimitedCompanyForm></LimitedCompanyForm>
            </div>
          </div>
        </template>
        <div v-else class="clearfix">
          <span class="float-start">Please complete your profile by clicking</span>
          <a href="/complete-profile" class="float-start">&nbsp;here</a>.
        </div>
      </div>
      <div v-if="activeName === 'control_panel'" class="col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 mx-auto">
        <ControlPanel></ControlPanel>
      </div>
      <div v-if="activeName === 'tax_and_registration'" class="col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 mx-auto">
        <TaxAndRegistration></TaxAndRegistration>
      </div>
      <div v-if="activeName === 'banking_and_paypal'" class="col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 mx-auto">
        <BankAndPayment></BankAndPayment>
      </div>
      <div v-if="activeName === 'change_password'" class="col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 mx-auto">
        <ChangePassword></ChangePassword>
      </div>
      <div v-if="activeName === 'accountant'" class="col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 mx-auto">
        <div class="card card-form">
          <div class="card-header">
            <div class="card-title">Accountant</div>
          </div>
          <div class="card-body text-center py-5">
            <p>Accountant settings content will be here.</p>
          </div>
        </div>
      </div>
      <div v-if="activeName === 'subscription'" class="col-12">
        <Subscription></Subscription>
      </div>
      <div v-if="activeName === 'voucher_referral_and_share'" class="col-12">
        <Voucher></Voucher>
      </div>
    </div>
  </div>
</template>


<script>
import SoleTraderForm from "../user/SoleTraderFormUpdate.vue";
import LimitedCompanyForm from "../user/LimitedCompanyFormUpdate.vue";
import General from "@/components/settings/General.vue";
import Subscription from "@/components/settings/Subscription.vue";
import ControlPanel from "@/components/settings/ControlPanel.vue";
import TaxAndRegistration from "@/components/settings/TaxAndRegistration.vue";
import BankAndPayment from "@/components/settings/BankAndPayment.vue";
import Voucher from "@/components/settings/Voucher.vue";
import ChangePassword from "@/components/auth/ChangePassword.vue";

export default {
  name: "SettingComponent",

  components: {
    SoleTraderForm,
    LimitedCompanyForm,
    General,
    Subscription,
    Voucher,
    ControlPanel,
    TaxAndRegistration,
    BankAndPayment,
    ChangePassword,
  },
  data() {
    return {
      loadingInstance: null,
      activeName: "general",
      isSoleTrader: false,
      isLimitedCompany: false,
    };
  },
  mounted() {
    //  console.log(this.$store.getters["auth/getUserData"].companytype);
    this.isSoleTrader =
      this.$store.getters["auth/getUserData"].companytype == "Sole Trader"
        ? true
        : false;
    this.isLimitedCompany =
      this.$store.getters["auth/getUserData"].companytype == "Limited Company"
        ? true
        : false;
    
    // Check if there's a pg query parameter and set the active tab
    if (this.$route.query.pg) {
      this.activeName = this.$route.query.pg;
    }
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.settings-header {
  position: sticky;
  top: 60px;
  z-index: 1050;
}

.settings-header .navbar {
  background-color: #f4f6f9;
  background-image: url('@/assets/images/system/seamless_pattern_gray.webp');
  background-repeat: repeat;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  /* margin-top: 10px; */
  margin-bottom: 10px;
}

.tab-content {
  position: relative;
  z-index: 0;
  isolation: isolate;
}

/* Override active tab color to blue for Limited Company users */
.settings-header .navbar.limited-company .nav-link.active {
  color: #1877f2 !important;
  border-bottom-color: #1877f2 !important;
}

/* Profile tab: company profile wizard shell (matches registration design) */
.st-wizard {
  width: 100%;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}
.st-heading {
  height: 55px;
  width: 210px;
  margin: 0;
  padding: 8px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px 8px 0 0;
}
.st-heading--navy {
  background: #1c4e80;
}
.st-heading--teal {
  background: #008490;
}
.st-card {
  background: #fbfbfc;
  padding: 34px 74px 40px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
@media (max-width: 520px) {
  .st-card {
    padding: 26px 20px 32px;
  }
}
</style>